import { createTextNode } from '../builders/hast-builders';
export const addBooleanAttributeToNode = (node, key, value = true) => {
    node.properties[key] = value === true ? '' : false;
    /* adding empty string as @starptech/prettyhtml-hast-to-html which we are currently
    using for generating HTML supports boolean way of adding attributes only for HTML
    attributes but not for Vue*/
};
export const addAttributeToNode = (node, key, value) => {
    node.properties[key] = value;
};
export const addClassToNode = (node, className) => {
    node.properties.class = className;
};
export const addChildNode = (node, child) => {
    node.children.push(child);
};
export const addTextNode = (node, text) => {
    node.children.push(createTextNode(text));
};
//# sourceMappingURL=hast-utils.js.map